import { t } from '@lingui/macro';
import i18n from 'config/i18n';
import generateActions from 'utils/actions';
import Genre from 'store/models/genre';
import Song from 'store/models/song';
import Tag from 'store/models/tag';
import User from 'store/models/user';

export const GET_CHARTS = generateActions('charts/GET_CHARTS');
export const GET_COUNTRIES = generateActions('charts/GET_COUNTRIES');
export const GET_GENRES = generateActions('charts/GET_GENRES');
export const GET_TAGS = generateActions('charts/GET_TAGS');
export const GET_ARTISTS = generateActions('charts/GET_ARTISTS');
export const DELETE_GENRE = generateActions('charts/DELETE_GENRE');
export const POST_GENRE = generateActions('charts/POST_GENRE');
export const PUT_GENRE = generateActions('charts/PUT_GENRE');
export const SET_FILTER = 'charts/SET_FILTER';
export const SET_FILTERS_I18N = 'charts/SET_FILTERS_I18N';

/**
 * Return a list of popular song based on the given
 * parameters
 */
export function loadCharts({ artists = [], genres = [], tags = [], vocals = [], instruments = [], moods = [], bpm, page = 0 }) {
  return {
    types: GET_CHARTS,
    promise: {
      url: '/discovers/songs',
      reader: {
        model: Song,
        root: 'songs',
      },
      data: {
        page,
        artists: artists.map(item => item.id).join(','),
        genres: genres.map(item => item.id).join(','),
        tags: tags.map(item => item.id).join(','),
        vocals: vocals.map(item => item.value).join(','),
        moods: moods.map(item => item.value).join(','),
        instruments: instruments.map(item => item.value).join(','),
        bpm: bpm.map(item => item.value).join(','),
      },
    },
  };
}

/**
 * Load all available genres in the platform
 */
export function loadGenres() {
  return {
    types: GET_GENRES,
    promise: {
      url: '/genres',
      reader: {
        model: Genre,
        root: 'genres',
      },
    },
  };
}

/**
 * Creates a new genre
 * @param {Genre} genre 
 */
export function postGenre(genre) {
  return {
    types: POST_GENRE,
    promise: {
      url: `/genres`,
      method: 'POST',
      form: {
        ...genre,
        image: genre.image instanceof File ? genre.image : undefined,
      },
    },
  };
}

/**
 * Updates the given genre
 * @param {Genre} genre 
 */
export function putGenre(genre) {
  return {
    types: PUT_GENRE,
    promise: {
      url: `/genres/${genre.id}`,
      method: 'POST',
      form: {
        ...genre,
        image: genre.image instanceof File ? genre.image : undefined,
      },
    },
  };
}

/**
 * Removes an existing genre
 * @param {Genre} genre 
 */
export function deleteGenre(genre) {
  return {
    types: DELETE_GENRE,
    promise: {
      url: `/genres/${genre.id}`,
      method: 'DELETE',
    },
    data: { genre },
  };
}

/**
 * Load all tags for songs
 */
export function loadTags() {
  return {
    types: GET_TAGS,
    promise: {
      url: '/tags/song',
      reader: {
        model: Tag,
        root: 'tags',
      },
    },
  };
}

/**
 * Load all countries where there's an artists
 */
export function loadCountries() {
  return {
    types: GET_COUNTRIES,
    promise: {
      url: '/users/countries',
      data: { authors: true },
    },
  };
}

/**
 * Load all tags for songs
 */
export function loadArtists() {
  return {
    types: GET_ARTISTS,
    promise: {
      url: '/artists/published',
      reader: {
        model: User,
        root: 'artists',
      },
    },
  };
}

export function setFilter(filter, value) {
  return {
    type: SET_FILTER,
    payload: {
      filter,
      value,
    },
  };
}

/**
 * Set the filter label values when the language changes
 */
export function setFilterI18nLabels() {
  return {
    type: SET_FILTERS_I18N,
    payload: {
      when: {
        list: [
          { id: 1, name: i18n._(t`Today`) },
          { id: 2, name: i18n._(t`This Week`) },
          { id: 3, name: i18n._(t`This Month`) },
          { id: 4, name: i18n._(t`This Year`) },
        ]
      },
    },
  };
}
